import { render, staticRenderFns } from "./NotQualifiedNum.vue?vue&type=template&id=0817b30f&scoped=true"
import script from "./NotQualifiedNum.vue?vue&type=script&lang=js"
export * from "./NotQualifiedNum.vue?vue&type=script&lang=js"
import style0 from "./NotQualifiedNum.vue?vue&type=style&index=0&id=0817b30f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0817b30f",
  null
  
)

export default component.exports